export default function initLoader() {

	const loader = document.querySelector('.loader')

	const videoLoader = document.querySelector('.video-loader')

	// loader
	if (loader) {
		let loaderBg = ["#DED3E8", "#EDE5DE", "#E4E5E6", "#D5DDE2", "#DBE4D5"]
		loader.style.backgroundColor = loaderBg[Math.floor(Math.random() * loaderBg.length)]

		document.body.classList.add('loading')
		setTimeout(() => {
			document.body.classList.add('loaded')
			document.body.classList.remove('loading')
		}, 3000)
	}

	// video-loader
	if (videoLoader) {
		let video = videoLoader.querySelector('video')
		video.play();

		document.body.classList.add('loading')

		video.addEventListener('ended',function(){
			document.body.classList.add('loaded')
			document.body.classList.remove('loading')
		});
	}

}